"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelAddressesView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const UserPanelSectionView_1 = require("./UserPanelSectionView");
const Element = (0, app_1.styled)(ui_1.Card) `
  height: 18.75rem;
  width: 18.75rem;
  background: #fbfbfb;
  padding: ${(theme) => theme.spacing.medium};
  color: black;
`;
const AdderWrap = (0, app_1.styled)(Element) `
  color: black;
`;
const AdderStack = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
const AdderInfo = app_1.styled.span `
  color: ${(theme) => theme.colors.gray};
`;
const CardHandler = app_1.styled.div `
  ${(theme) => theme.flexCenter}
  height: 100%;
  cursor: pointer;
`;
function Adder({ openModal }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(AdderWrap, { children: (0, jsx_runtime_1.jsx)(CardHandler, Object.assign({ onClick: () => openModal() }, { children: (0, jsx_runtime_1.jsxs)(AdderStack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(svg_1.SvgPlus, {}), (0, jsx_runtime_1.jsx)(AdderInfo, { children: t('info.addAddress') })] })) })) }) }));
}
const AddressIntro = app_1.styled.span `
  font-size: 0.9375rem;
  color: ${(theme) => theme.colors.gray.dark};
  font-weight: 400;
`;
const AddressesGrid = (0, app_1.styled)(ui_1.Grid) `
  grid-template-columns: minmax(0, 1fr);

  @media ${app_1.desktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${app_1.bigScreen} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;
const Title = app_1.styled.span `
  font-weight: 500;
  font-size: 1.0625rem;
`;
function AddressElement({ address }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "small" }, { children: [(0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(AddressIntro, { children: t('store.label.address') }), (0, jsx_runtime_1.jsx)(Title, { children: address.title })] })), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span" }, { children: [address.address, " ", address.address2] })), (0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span" }, { children: [address.postalCode, " ", address.city] })), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: address.country }))] }))] })));
}
function UserPanelAddressesView({ addresses, openModal, }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(UserPanelSectionView_1.UserPanelSectionView, Object.assign({ title: t('store.Addresses') }, { children: (0, jsx_runtime_1.jsxs)(AddressesGrid, { children: [(0, jsx_runtime_1.jsx)(Adder, { openModal: openModal }), addresses.map((address) => ((0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(Element, { children: (0, jsx_runtime_1.jsx)(AddressElement, { address: address }) }) }, address.id)))] }) })));
}
exports.UserPanelAddressesView = UserPanelAddressesView;
